export default function () {
  controller('popup-comments', self => {
    const $comments = $(self);
    
    $comments.each(function() {
      const self = $(this);
      const $btn = self.find('.js-popup-comments-btn');
      const $list = self.find('.js-popup-comments-list');

      $btn.on('click', function() {
        $list.toggleClass('open');
      });
    })
  });
}